import { AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';

import '@/components/AutoshipBadge/AutoshipBadge.scss';

export type AutoshipBadgeTextProps = Readonly<{
    discountDisplay?: string;
    isPerSkuSubscribedIndicatorEnabled?: boolean;
    isCustomerSubscribedToTileSku?: boolean;
    isExistingAutoshipSubscriber?: boolean;
}>;

type AutoshipBadgeTextComponentProps = AutoshipBadgeTextProps & {
    icon?: React.ReactNode;
};

export const AutoshipBadgeText = ({
    discountDisplay,
    isPerSkuSubscribedIndicatorEnabled = false,
    isCustomerSubscribedToTileSku = false,
    isExistingAutoshipSubscriber = false,
    icon,
}: AutoshipBadgeTextComponentProps) => {
    // MAP-restricted SKUs omit a usable discountDisplay. It matches PDP condition.
    const hasDiscountDisplay = Boolean(discountDisplay?.trim());

    if (isPerSkuSubscribedIndicatorEnabled && isCustomerSubscribedToTileSku) {
        return <WithAutoshipMessaging lead="Subscribed with" icon={icon} />;
    }

    if (isExistingAutoshipSubscriber && hasDiscountDisplay) {
        return (
            <AutoshipDiscountPromoMessaging
                discountDisplay={AUTOSHIP_RECURRING_ORDERS_DISCOUNT}
                orderLabel="orders with"
                icon={icon}
            />
        );
    }

    if (hasDiscountDisplay && discountDisplay) {
        return (
            <AutoshipDiscountPromoMessaging
                discountDisplay={discountDisplay}
                orderLabel="first order with"
                icon={icon}
            />
        );
    }

    return <WithAutoshipMessaging lead="Subscribe with" icon={icon} />;
};

const WithAutoshipMessaging = ({
    lead,
    icon,
}: {
    lead: 'Subscribe with' | 'Subscribed with';
    icon?: React.ReactNode;
}) => (
    <span className="autoship-badge__promo" data-testid="autoship-badge-promo">
        <span>{lead}</span>
        <span className="autoship-badge__brand-lockup" data-testid="autoship-badge-brand-lockup">
            <span className="autoship-badge__text-brand" data-testid="autoship-badge-brand">
                Autoship
            </span>
            {icon}
        </span>
    </span>
);

const AutoshipDiscountPromoMessaging = ({
    discountDisplay,
    orderLabel,
    icon,
}: {
    discountDisplay: string;
    orderLabel: 'orders with' | 'first order with';
    icon?: React.ReactNode;
}) => (
    <span className="autoship-badge__promo" data-testid="autoship-badge-promo">
        <span className="autoship-badge__discount">{discountDisplay} off</span>
        <span>{orderLabel}</span>
        <span className="autoship-badge__brand-lockup" data-testid="autoship-badge-brand-lockup">
            <span className="autoship-badge__text-brand" data-testid="autoship-badge-brand">
                Autoship
            </span>
            {icon}
        </span>
    </span>
);
